<h1 style="text-align: center;">
  {{ 'COMMON.PAGE_NOT_FOUND' | translate }}
</h1>
